// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ApiParameter, post } from "@insite/client-framework/Services/ApiService";
import { TellAFriendModel } from "@insite/client-framework/Types/ApiModels";

const emailsUrl = "/api/v1/awc/email";

export interface TellAFriendApiParameter extends ApiParameter {
    tellAFriendModel: TellAFriendModel;
    reCaptchaResponse: string;
}

export async function tellAFriend(parameter: TellAFriendApiParameter) {
    try {
        const result = await post<TellAFriendApiParameter>(`${emailsUrl}/tellafriend`, parameter);

        return {
            successful: true,
            result,
        };
    } catch (error) {
        if ("status" in error && (error.status === 400 || error.status === 500)) {
            return {
                successful: false,
                errorMessage: error?.errorJson?.message || error?.errorMessage || "error",
                statusCode: error.status,
            };
        }
        throw error;
    }
}
